import React from 'react'
import API from '../../services/api.jsx'
import Loader from '../layout/loader.jsx'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Table from '../layout/table.jsx'
import moment from 'moment'
import { debounce } from 'lodash'
import Helpers from '../../services/helpers.jsx'
import { toast } from 'react-toastify'

class PlaylistList extends React.PureComponent {
	constructor(props) {
		super(props)

		const tabsLinks = [];
		if (Helpers.checkPermissions("playlists:list")) {
			tabsLinks.push({ title: 'Playlists', path: '/assets/playlists' });
		}
		if (Helpers.checkPermissions("collections:list")) {
			tabsLinks.push({ title: 'Collections', path: '/assets/collections' });
		}

		const actions = [];
		if (Helpers.checkPermissions("playlists:edit")) {
			actions.push({
				classList: 'blue add',
				label: 'New playlist',
				onClick: () => this.props.history.push('/assets/playlists/new')
			});
		}

		const columns = [
      {
        label: 'Playlist name',
        key: 'name',
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: 'Tracks',
        key: 'assets',
        view: function (field) {
          return field ? field.length : '-';
        },
      },
      {
        label: 'Duration',
        key: 'duration',
        view: function (field) {
          return field ? Helpers.formatTime(field) : '-';
        },
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: 'Usage',
        key: 'linkedCampaigns',
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: 'Vox tag',
        key: 'tag',
      },
      {
        label: 'Type',
        key: 'type',
        view: (field) => {
          return Helpers.getPlaylistTypeLabel(field);
        },
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: 'Affiliate',
        key: 'affiliates',
        view: (field) => {
          if (Array.isArray(field)) {
            if (field.length === 0) {
              return 'All';
            } else {
              return field?.map((affiliate) => affiliate.name)?.join(', ');
            }
          } else {
            return '-';
          }
        },
      },
      {
        label: 'Creation date',
        key: 'createdAt',
        view: function (field) {
          return field ? moment(field).format('l') : '-';
        },
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: 'Modified date',
        key: 'updatedAt',
        view: function (field) {
          return field ? moment(field).format('l') : '-';
        },
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
    ];
		if (Helpers.checkPermissions("playlists:delete")) {
			columns.push({
				action: 'delete',
				onClick: (id) => {
					var r = window.confirm("Are you sure you want to delete this playlist?");
					if (r === false) return

					this.setState({ loading: true })
					API.delete('playlists', id).then(() => {
						toast.success('Playlist was successfully deleted')
						this.loadEntities()
					}).catch(() => {
						// toast.success('An unexpected error has occurred')
						this.setState({ loading: false })
					})
				}
			});
		}

		this.state = {
			clients: [],
			loading: true,
			search: '',
			filters: {},
			sort: ['updatedAt', 'DESC'],
			tabs: {
				links: tabsLinks,
			},
			playlists: {
				columns,
				entities: [],
				filters: [
					{
						label: 'Search for a playlist',
						onChange: debounce(value => {
							if(value !== this.state.search)
								this.setState({ 
									search: value,
									filters: { 
										...this.state.filters, 
										q: value,
									}}, () => {
									this.loadEntities()
								})
						}, 500)
					},
					{
						label: 'Select type',
						type: 'select',
						value: null,
						placeholder: 'Select type',
						isClearable: true, 
						entities: Helpers.getPlaylistTypeFilterOptions(),
						onChange: value => {
							if(value !== this.state.filters?.type) {
								const newFilters = [...this.state.playlists.filters];
								newFilters[1].value = value
								let newFilter = { ...this.state.filters, type: value ? value.id : '' }
								newFilter = Helpers.cleanObject(newFilter);
								this.setState({
									filters: newFilter,
									playlists: {
										...this.state.playlists,
										filters: newFilters
									}
								}, () => {
									this.loadEntities();
								})
							}
						}
					},
					{
						label: 'Affiliate',
						type: 'select',
						value: null,
						placeholder: 'Affiliate',
						isClearable: true, 
						onChange: value => {
							if (value !== this.state.filters?.affiliate) {
								const newFilters = [...this.state.playlists.filters];
								newFilters[2].value = value

								let newFilter = {
									...this.state.filters,
									affiliate: value?.id,
								}
								newFilter = Helpers.cleanObject(newFilter);
								this.setState({
									filters: newFilter,
									playlists: {
										...this.state.playlists,
										filters: newFilters
									}
								}, () => {
									this.loadEntities();
								})
							}
						}
					}
				],
				actions,
				selectedItems: [],
				multiSelect: false,
				onRowClick: (entity) => {
					if (
						Helpers.checkPermissions(
							["playlists:details", "playlists:edit"],
							true
						)
					) {
						this.props.history.push('/assets/playlists/' + entity.id)
					}
				}
			}
		}
	}

	componentDidMount() {
		this.loadEntities()
	}

	onSort(key){
		const newSort = this.state?.sort?.[0] === key ? 
		this.state?.sort?.[1] === "ASC" ? [key, 'DESC'] : [key, 'ASC'] 
		: [key, 'ASC'];
		this.setState({
			sort: newSort
		}, () => {
			this.loadEntities()
		})
	}

	loadEntities() {
    API.getPlaylists(this.state.filters, this.state.sort)
      .then((entities) => {
		const filters = [];
		if (entities?.filters?.availableFilters) {
			Helpers.handleFilters(this, filters, entities);
		}

        this.setState({
          ...this.state,
          playlists: {
            ...this.state.playlists,
            filters,
            entities: entities?.data || [],
          },
          loading: false,
        });
      })
      .catch((err) => {
        // toast.error(
        //   err.response?.data?.message || "An unexpected error has occurred"
        // );
        this.setState({ loading: false });
      });
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head title={'Playlist'} tabs={this.state.tabs} />
				<Content>
					<Table settings={this.state.playlists} loadEntities={this.loadEntities} sort={this.state.sort}/>
				</Content>
			</>
	}
}

export default PlaylistList;
